import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../configs/client";

export const getDahboardDetails = createAsyncThunk(
  "dashboard/all-details",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.get(`/home/all-details`);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const getRecentFiles = createAsyncThunk(
  "dashboard/recent-files",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const { data } = await client.get(`/home/recent-files`
        // , {
        //   params: { user_id },
        // }
      );
      console.log("data", data);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    error: null,
    isFetching: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getDahboardDetails.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getDahboardDetails.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getDahboardDetails.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action?.payload;
      })
      .addCase(getRecentFiles.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getRecentFiles.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(getRecentFiles.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action?.payload;
      });
  },
});

export default dashboardSlice.reducer;
